const routes = [
  // 碳管理
  {
    // 碳总览
    path: "/carbon/carbonOverview",
    name: "carbonOverview",
    component: () => import("@src/modules/carbonManage/view/carbonOverview"),
    meta: {
      requireAuth: false,
      routerAlive: false
    }
  },
  {
    // 碳目标
    path: "/carbon/carbonTarget",
    name: "carbonTarget",
    component: () => import("@src/modules/carbonManage/view/carbonTarget"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    // 碳交易
    path: "/carbon/carbonTrading",
    name: "carbonTrading",
    component: () => import("@src/modules/carbonManage/view/carbonTrading"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    // 标准因子库
    path: "/carbon/standardFactor",
    name: "standardFactor",
    component: () => import("@src/modules/carbonManage/view/standardFactor"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    // 碳核算
    path: "/carbon/carbonAccount",
    name: "carbonAccount",
    component: () => import("@src/modules/carbonManage/view/carbonAccount"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    // 碳减排
    path: "/carbon/carbonReduction",
    name: "carbonReduction",
    component: () => import("@src/modules/carbonManage/view/carbonReduction"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    // 燃料消耗
    path: "/carbon/fuelConsumption",
    name: "fuelConsumption",
    component: () => import("@src/modules/carbonManage/view/fuelConsumption"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
];

export default routes;